import moment from "moment";
import "moment/locale/id";

export const convertUserList = (data) => {
  let converted = [];

  if (!data) return [];

  data.forEach((item, index) => {
    converted.push({
      key: index + 1,
      userId: item.id,
      employeeId: item.employee.id,
      name: `${item.employee.first_name} ${item.employee.last_name}`,
      phone: `${item.employee.phone}`,
      email: item.email,
      outlet: item.employee.outlet.name,
      role: item.role.name,
      lastLogin:
        item?.user_login?.last_login === "0001-01-01T00:00:00Z"
          ? "Belum Pernah"
          : moment(item?.user_login?.last_login).format("DD MMMM YYYY"),
      status: item.is_active ? "Aktif" : "Non Aktif",
      item: item,
      verify: item.is_reset_password,
    });
  });
  return converted;
};
